import { REGION_CATALOG } from "@shared/constants/regions.catalog";

export type PredefinedAreaId =
  | 'jalisco'
  | 'amg'
  | 'norte'
  | 'altos_norte'
  | 'altos_sur'
  | 'cienaga'
  | 'sureste'
  | 'sur'
  | 'sierra_amula'
  | 'costa_sur'
  | 'costa_sierra'
  | 'sierra_occidental'
  | 'costa_norte'
  | 'zona_costera'
  | 'lagunas_secas'
  | 'valles'
  | 'centro'
  | 'lagunas'
  | 'encarnacion_de_diaz'
  | 'lagos_de_moreno'
  | 'villa_hidalgo'
  | 'union_de_san_antonio'
  | 'ojuelos_de_jalisco'
  | 'teocaltiche'
  | 'san_diego_de_alejandria'
  | 'san_juan_de_los_lagos'
  | 'jesus_maria'
  | 'mexticacan'
  | 'acatic'
  | 'jalostotitlan'
  | 'tepatitlan_de_morelos'
  | 'valle_de_guadalupe'
  | 'canadas_de_obregon'
  | 'yahualica_de_gonzalez_gallo'
  | 'san_julian'
  | 'san_miguel_el_alto'
  | 'san_ignacio_cerro_gordo'
  | 'arandas'
  | 'ixtlahuacan_de_los_membrillos'
  | 'zapopan'
  | 'tonala'
  | 'san_pedro_tlaquepaque'
  | 'tlajomulco_de_zuniga'
  | 'juanacatlan'
  | 'cuquio'
  | 'guadalajara'
  | 'san_cristobal_de_la_barranca'
  | 'el_salto'
  | 'ixtlahuacan_del_rio'
  | 'zapotlanejo'
  | 'ocotlan'
  | 'ayotlan'
  | 'atotonilco_el_alto'
  | 'degollado'
  | 'la_barca'
  | 'tototlan'
  | 'zapotlan_del_rey'
  | 'poncitlan'
  | 'jamay'
  | 'puerto_vallarta'
  | 'san_sebastian_del_oeste'
  | 'mixtlan'
  | 'mascota'
  | 'talpa_de_allende'
  | 'cabo_corrientes'
  | 'atenguillo'
  | 'guachinango'
  | 'casimiro_castillo'
  | 'cihuatlan'
  | 'tomatlan'
  | 'cuautitlan_de_garcia_barragan'
  | 'villa_purificacion'
  | 'la_huerta'
  | 'tapalpa'
  | 'techaluta_de_montenegro'
  | 'san_martin_hidalgo'
  | 'teocuitatlan_de_corona'
  | 'atemajac_de_brizuela'
  | 'sayula'
  | 'villa_corona'
  | 'cocula'
  | 'amacueca'
  | 'zacoalco_de_torres'
  | 'acatlan_de_juarez'
  | 'atoyac'
  | 'santa_maria_de_los_angeles'
  | 'huejucar'
  | 'san_martin_de_bolanos'
  | 'villa_guerrero'
  | 'colotlan'
  | 'chimaltitan'
  | 'huejuquilla_el_alto'
  | 'mezquitic'
  | 'totatiche'
  | 'bolanos'
  | 'tonaya'
  | 'juchitlan'
  | 'tuxcacuesco'
  | 'tecolotlan'
  | 'union_de_tula'
  | 'ayutla'
  | 'tenamaxtlan'
  | 'el_limon'
  | 'el_grullo'
  | 'cuautla'
  | 'ejutla'
  | 'autlan_de_navarro'
  | 'atengo'
  | 'chiquilistlan'
  | 'tamazula_de_gordiano'
  | 'jilotlan_de_los_dolores'
  | 'zapotitlan_de_vadillo'
  | 'zapotiltic'
  | 'san_gabriel'
  | 'pihuamo'
  | 'tuxpan'
  | 'tonila'
  | 'zapotlan_el_grande'
  | 'tecalitlan'
  | 'gomez_farias'
  | 'toliman'
  | 'quitupan'
  | 'chapala'
  | 'jocotepec'
  | 'la_manzanilla_de_la_paz'
  | 'mazamitla'
  | 'valle_de_juarez'
  | 'santa_maria_del_oro'
  | 'tuxcueca'
  | 'tizapan_el_alto'
  | 'concepcion_de_buenos_aires'
  | 'amatitan'
  | 'ameca'
  | 'san_juanito_de_escobedo'
  | 'magdalena'
  | 'hostotipaquillo'
  | 'ahualulco_de_mercado'
  | 'etzatlan'
  | 'tequila'
  | 'teuchitlan'
  | 'tala'
  | 'san_marcos'
  | 'el_arenal'
  | 'tepic';

export type PredefinedAreaType = 'state' | 'region' | 'zone' | 'municipality';

export interface PredefinedAreaOption {
  value: PredefinedAreaId;
  label: string;
  type: PredefinedAreaType;
}

export const PREDEFINED_AREAS: PredefinedAreaOption[] = [
  // Estado
  { value: 'jalisco', label: 'Estado de Jalisco', type: 'state' },
  
  // Zonas
  ...REGION_CATALOG
    .filter(region => !region.deprecated && region.slug !== 'jalisco')
    .map(region => ({
      value: region.slug as PredefinedAreaId,
      label: region.type === 'region' ? `Región ${region.name}` : region.name,
      type: (region.type === 'region' ? 'region' : 'zone') as PredefinedAreaType,
    })),
  
  
  // Municipios
  { value: 'encarnacion_de_diaz', label: 'Encarnación de Díaz', type: 'municipality' },
  { value: 'lagos_de_moreno', label: 'Lagos de Moreno', type: 'municipality' },
  { value: 'villa_hidalgo', label: 'Villa Hidalgo', type: 'municipality' },
  { value: 'union_de_san_antonio', label: 'Unión de San Antonio', type: 'municipality' },
  { value: 'ojuelos_de_jalisco', label: 'Ojuelos de Jalisco', type: 'municipality' },
  { value: 'teocaltiche', label: 'Teocaltiche', type: 'municipality' },
  { value: 'san_diego_de_alejandria', label: 'San Diego de Alejandría', type: 'municipality' },
  { value: 'san_juan_de_los_lagos', label: 'San Juan de los Lagos', type: 'municipality' },
  { value: 'jesus_maria', label: 'Jesús María', type: 'municipality' },
  { value: 'mexticacan', label: 'Mexticacán', type: 'municipality' },
  { value: 'acatic', label: 'Acatic', type: 'municipality' },
  { value: 'jalostotitlan', label: 'Jalostotitlán', type: 'municipality' },
  { value: 'tepatitlan_de_morelos', label: 'Tepatitlán de Morelos', type: 'municipality' },
  { value: 'valle_de_guadalupe', label: 'Valle de Guadalupe', type: 'municipality' },
  { value: 'canadas_de_obregon', label: 'Cañadas de Obregón', type: 'municipality' },
  { value: 'yahualica_de_gonzalez_gallo', label: 'Yahualica de González Gallo', type: 'municipality' },
  { value: 'san_julian', label: 'San Julián', type: 'municipality' },
  { value: 'san_miguel_el_alto', label: 'San Miguel el Alto', type: 'municipality' },
  { value: 'san_ignacio_cerro_gordo', label: 'San Ignacio Cerro Gordo', type: 'municipality' },
  { value: 'arandas', label: 'Arandas', type: 'municipality' },
  { value: 'ixtlahuacan_de_los_membrillos', label: 'Ixtlahuacán de los Membrillos', type: 'municipality' },
  { value: 'zapopan', label: 'Zapopan', type: 'municipality' },
  { value: 'tonala', label: 'Tonalá', type: 'municipality' },
  { value: 'san_pedro_tlaquepaque', label: 'San Pedro Tlaquepaque', type: 'municipality' },
  { value: 'tlajomulco_de_zuniga', label: 'Tlajomulco de Zúñiga', type: 'municipality' },
  { value: 'juanacatlan', label: 'Juanacatlán', type: 'municipality' },
  { value: 'cuquio', label: 'Cuquío', type: 'municipality' },
  { value: 'guadalajara', label: 'Guadalajara', type: 'municipality' },
  { value: 'san_cristobal_de_la_barranca', label: 'San Cristóbal de la Barranca', type: 'municipality' },
  { value: 'el_salto', label: 'El Salto', type: 'municipality' },
  { value: 'ixtlahuacan_del_rio', label: 'Ixtlahuacán del Río', type: 'municipality' },
  { value: 'zapotlanejo', label: 'Zapotlanejo', type: 'municipality' },
  { value: 'ocotlan', label: 'Ocotlán', type: 'municipality' },
  { value: 'ayotlan', label: 'Ayotlán', type: 'municipality' },
  { value: 'atotonilco_el_alto', label: 'Atotonilco el Alto', type: 'municipality' },
  { value: 'degollado', label: 'Degollado', type: 'municipality' },
  { value: 'la_barca', label: 'La Barca', type: 'municipality' },
  { value: 'tototlan', label: 'Tototlán', type: 'municipality' },
  { value: 'zapotlan_del_rey', label: 'Zapotlán del Rey', type: 'municipality' },
  { value: 'poncitlan', label: 'Poncitlán', type: 'municipality' },
  { value: 'jamay', label: 'Jamay', type: 'municipality' },
  { value: 'puerto_vallarta', label: 'Puerto Vallarta', type: 'municipality' },
  { value: 'san_sebastian_del_oeste', label: 'San Sebastián del Oeste', type: 'municipality' },
  { value: 'mixtlan', label: 'Mixtlán', type: 'municipality' },
  { value: 'mascota', label: 'Mascota', type: 'municipality' },
  { value: 'talpa_de_allende', label: 'Talpa de Allende', type: 'municipality' },
  { value: 'cabo_corrientes', label: 'Cabo Corrientes', type: 'municipality' },
  { value: 'atenguillo', label: 'Atenguillo', type: 'municipality' },
  { value: 'guachinango', label: 'Guachinango', type: 'municipality' },
  { value: 'casimiro_castillo', label: 'Casimiro Castillo', type: 'municipality' },
  { value: 'cihuatlan', label: 'Cihuatlán', type: 'municipality' },
  { value: 'tomatlan', label: 'Tomatlán', type: 'municipality' },
  { value: 'cuautitlan_de_garcia_barragan', label: 'Cuautitlán de García Barragán', type: 'municipality' },
  { value: 'villa_purificacion', label: 'Villa Purificación', type: 'municipality' },
  { value: 'la_huerta', label: 'La Huerta', type: 'municipality' },
  { value: 'tapalpa', label: 'Tapalpa', type: 'municipality' },
  { value: 'techaluta_de_montenegro', label: 'Techaluta de Montenegro', type: 'municipality' },
  { value: 'san_martin_hidalgo', label: 'San Martín Hidalgo', type: 'municipality' },
  { value: 'teocuitatlan_de_corona', label: 'Teocuitatlán de Corona', type: 'municipality' },
  { value: 'atemajac_de_brizuela', label: 'Atemajac de Brizuela', type: 'municipality' },
  { value: 'sayula', label: 'Sayula', type: 'municipality' },
  { value: 'villa_corona', label: 'Villa Corona', type: 'municipality' },
  { value: 'cocula', label: 'Cocula', type: 'municipality' },
  { value: 'amacueca', label: 'Amacueca', type: 'municipality' },
  { value: 'zacoalco_de_torres', label: 'Zacoalco de Torres', type: 'municipality' },
  { value: 'acatlan_de_juarez', label: 'Acatlán de Juárez', type: 'municipality' },
  { value: 'atoyac', label: 'Atoyac', type: 'municipality' },
  { value: 'santa_maria_de_los_angeles', label: 'Santa María de los Ángeles', type: 'municipality' },
  { value: 'huejucar', label: 'Huejúcar', type: 'municipality' },
  { value: 'san_martin_de_bolanos', label: 'San Martín de Bolaños', type: 'municipality' },
  { value: 'villa_guerrero', label: 'Villa Guerrero', type: 'municipality' },
  { value: 'colotlan', label: 'Colotlán', type: 'municipality' },
  { value: 'chimaltitan', label: 'Chimaltitán', type: 'municipality' },
  { value: 'huejuquilla_el_alto', label: 'Huejuquilla el Alto', type: 'municipality' },
  { value: 'mezquitic', label: 'Mezquitic', type: 'municipality' },
  { value: 'totatiche', label: 'Totatiche', type: 'municipality' },
  { value: 'bolanos', label: 'Bolaños', type: 'municipality' },
  { value: 'tonaya', label: 'Tonaya', type: 'municipality' },
  { value: 'juchitlan', label: 'Juchitlán', type: 'municipality' },
  { value: 'tuxcacuesco', label: 'Tuxcacuesco', type: 'municipality' },
  { value: 'tecolotlan', label: 'Tecolotlán', type: 'municipality' },
  { value: 'union_de_tula', label: 'Unión de Tula', type: 'municipality' },
  { value: 'ayutla', label: 'Ayutla', type: 'municipality' },
  { value: 'tenamaxtlan', label: 'Tenamaxtlán', type: 'municipality' },
  { value: 'el_limon', label: 'El Limón', type: 'municipality' },
  { value: 'el_grullo', label: 'El Grullo', type: 'municipality' },
  { value: 'cuautla', label: 'Cuautla', type: 'municipality' },
  { value: 'ejutla', label: 'Ejutla', type: 'municipality' },
  { value: 'autlan_de_navarro', label: 'Autlán de Navarro', type: 'municipality' },
  { value: 'atengo', label: 'Atengo', type: 'municipality' },
  { value: 'chiquilistlan', label: 'Chiquilistlán', type: 'municipality' },
  { value: 'tamazula_de_gordiano', label: 'Tamazula de Gordiano', type: 'municipality' },
  { value: 'jilotlan_de_los_dolores', label: 'Jilotlán de los Dolores', type: 'municipality' },
  { value: 'zapotitlan_de_vadillo', label: 'Zapotitlán de Vadillo', type: 'municipality' },
  { value: 'zapotiltic', label: 'Zapotiltic', type: 'municipality' },
  { value: 'san_gabriel', label: 'San Gabriel', type: 'municipality' },
  { value: 'pihuamo', label: 'Pihuamo', type: 'municipality' },
  { value: 'tuxpan', label: 'Tuxpan', type: 'municipality' },
  { value: 'tonila', label: 'Tonila', type: 'municipality' },
  { value: 'zapotlan_el_grande', label: 'Zapotlán el Grande', type: 'municipality' },
  { value: 'tecalitlan', label: 'Tecalitlán', type: 'municipality' },
  { value: 'gomez_farias', label: 'Gómez Farías', type: 'municipality' },
  { value: 'toliman', label: 'Tolimán', type: 'municipality' },
  { value: 'quitupan', label: 'Quitupan', type: 'municipality' },
  { value: 'chapala', label: 'Chapala', type: 'municipality' },
  { value: 'jocotepec', label: 'Jocotepec', type: 'municipality' },
  { value: 'la_manzanilla_de_la_paz', label: 'La Manzanilla de la Paz', type: 'municipality' },
  { value: 'mazamitla', label: 'Mazamitla', type: 'municipality' },
  { value: 'valle_de_juarez', label: 'Valle de Juárez', type: 'municipality' },
  { value: 'santa_maria_del_oro', label: 'Santa María del Oro', type: 'municipality' },
  { value: 'tuxcueca', label: 'Tuxcueca', type: 'municipality' },
  { value: 'tizapan_el_alto', label: 'Tizapán el Alto', type: 'municipality' },
  { value: 'concepcion_de_buenos_aires', label: 'Concepción de Buenos Aires', type: 'municipality' },
  { value: 'amatitan', label: 'Amatitán', type: 'municipality' },
  { value: 'ameca', label: 'Ameca', type: 'municipality' },
  { value: 'san_juanito_de_escobedo', label: 'San Juanito de Escobedo', type: 'municipality' },
  { value: 'magdalena', label: 'Magdalena', type: 'municipality' },
  { value: 'hostotipaquillo', label: 'Hostotipaquillo', type: 'municipality' },
  { value: 'ahualulco_de_mercado', label: 'Ahualulco de Mercado', type: 'municipality' },
  { value: 'etzatlan', label: 'Etzatlán', type: 'municipality' },
  { value: 'tequila', label: 'Tequila', type: 'municipality' },
  { value: 'teuchitlan', label: 'Teuchitlán', type: 'municipality' },
  { value: 'tala', label: 'Tala', type: 'municipality' },
  { value: 'san_marcos', label: 'San Marcos', type: 'municipality' },
  { value: 'el_arenal', label: 'El Arenal', type: 'municipality' },
];


